const TW_JS = `<script>
function callAfterTwitterInitialization(callback){
  if(typeof twttr !== 'undefined'){
    callback();
  } else {
    setTimeout(function(){
      callAfterTwitterInitialization(callback);
    }, 100);
  }
}
!function(d,s,id){
  var js,fjs=d.getElementsByTagName(s)[0],
      p=/^http:/.test(d.location)?'http':'https';
  if(!d.getElementById(id)){
    js=d.createElement(s);
    js.id=id;
    js.src=p+'://platform.twitter.com/widgets.js';
    fjs.parentNode.insertBefore(js,fjs);
  } else {
    callAfterTwitterInitialization(function(){
      twttr.widgets.load();
    });
  }
}(document, 'script', 'twitter-wjs');
</script>`;

export default TW_JS;
